<template>
  <button class="app-button" @click="$emit('onclick')">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "AppButton",
};
</script>

<style scoped>
.app-button {
  color: #fff;
  background: #0073c3;
  border-radius: 5px;
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  margin: 10px 0 0 10px;
}
</style>